import { Redirect, Route, useLocation } from 'react-router-dom';

import api from 'api/client';
import React from 'react';
import { userStore } from 'store/UserStore';

const CustomerRoute = ({ component: Component, ...rest }) => {
  const token = api.getToken();
  const [user, customerId, hasHydrated] = userStore((state: any) => [
    state.user,
    state.customerId,
    state.hasHydrated,
  ]);
  const location = useLocation();

  return (
    <Route
      {...rest}
      render={(props) => {
        // Zustand's persisted auth state (customerId) rehydrates from
        // localStorage asynchronously. On a hard page reload (e.g. the
        // full-page redirect back from Easebuzz's hosted checkout), the
        // first render(s) can see customerId still empty even though the
        // user is authenticated, which would otherwise bounce them to
        // /customers before hydration finishes. Wait for hydration first.
        if (!hasHydrated) return null;
        return token && customerId ? (
          <Component {...props} />
        ) : (
          <Redirect to={'/customers'} />
        );
      }}
    />
  );
};

export default CustomerRoute;
